module.exports = __webpack_public_path__ + "img/contract-red.24fb258f.svg";